module.exports = __webpack_public_path__ + "static/candle_of_invocation-1b56c138611e74070708301b3137abea.jpeg";